/**
 * 金融機関支店検索
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'
 
 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/branches`
 
 const search_branch = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
     /**
      * 金融機関支店一覧の取得.
      * ドロップダウンで表示可能な内容を返します.
      * @return {Promise<unknown>}
      */
      index () {
        return new Promise((resolve) => {
          Vue.$http.get(API_PATH).then(data => {
            resolve(data.content)
          })
        })
      },
     /**
      * 金融機関支店情報の取得.
      * @param commit
      * @param { String } id コード
      * @return {Promise<unknown>}
      */
     show ({ commit }, { code }) {
       const api_path = `${API_PATH}/${code}`
       return new Promise((resolve) => {
         Vue.$http.get(api_path).then(data => {
           resolve(data.content)
         })
       })
     },
   },
   mutations: {},
 }
 export default search_branch
 